import { useSetPageMeta as e } from "./useSetPageMeta.mjs";
//#region src/useSetPageTitle.ts
var t = (t) => e(t === void 0 ? void 0 : { title: t });
//#endregion
export { t as useSetPageTitle };
